module.exports = __webpack_public_path__ + "static/media/calendar-clean.c60729b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/calendar-clean.svg
// module id = 2681
// module chunks = 0